


































































import PosterUser from '../mixins/poster-user'
import Worker from './Worker.vue'
import InputDialog from './InputDialog.vue'
import ReloadButton from '@/components/ReloadButton.vue'
import StatusChip from '@/components/StatusChip.vue'
import { getIdFromURL } from 'vue-youtube-embed'
import Pdfpreview from '../components/Pdfpreview.vue'
import posterService from '../services/poster'
import { SimplePoster } from '../models/poster'

export default PosterUser.extend({
  components: {
    Worker,
    InputDialog,
    ReloadButton,
    StatusChip,
    Pdfpreview,
  },

  props: {
    revisor: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    posterType: 'eval',
    filter: (p: SimplePoster) => p._vp,
    dialog_: true,
    play: { autoplay: true },
    tab: null as number | null,
  }),

  watch: {
    poster(v) {
      this.play = {
        autoplay: !!v,
      }
    },
  },

  computed: {
    async fileURL() {
      const poster = this?.poster
      if (!poster) {
        return null
      }

      let blob: Blob
      try {
        blob = await posterService.fetchFile(poster)
      } catch (err) {
        return null
      }

      return URL.createObjectURL(blob)
    },

    videoID() {
      return this.poster?.url_video && getIdFromURL(this.poster.url_video)
        ? getIdFromURL(this.poster.url_video)
        : ''
    },

    type() {
      return this.revisor ? 'all' : 'eval'
    },
  },

  methods: {
    dismiss() {
      this.visible = false
      this.tab = null
    },

    evaluar() {
      this.$emit('evaluar', this.value)
      ;(this as any).dismiss()
    },
  },

  created() {
    this.bindPosterType('type')
  },
})
